import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar, Footer, SEO } from '../common';
import FloatingButtons from '../common/FloatingButtons';

export default function ServiceLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* SEO 기본 메타 폴백(페이지에서 <SEO route=.../> 로 보강).
          Organization(TravelAgency) JSON-LD·aggregateRating 은 정적 프리렌더(inject_seo)에서 주입 →
          런타임 중복 방지(리치결과 org 중복 제거). */}
      <SEO />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
